export const PREFILTERS_CONFIG = [
  {
    id: 'checked',
    filter: 'verified',
    value: 1
  },
  {
    id: 'students',
    filter: 'features[]',
    value: 'students'
  },
  {
    id: 'wifi',
    filter: 'features[]',
    value: 'wifi'
  },
  {
    id: 'long-stays',
    filter: 'rentalType[]',
    value: 'longTerm'
  },
  {
    id: 'cheapest',
    filter: 'budget',
    value: '0-700'
  },
  {
    id: 'pets',
    filter: 'features[]',
    value: 'pets'
  }
];

export default {
  PREFILTERS_CONFIG
};
